import { createAnimator } from './core/create-animator.mjs';
import { fadeIn } from './presets/fade-in.mjs';
import { fadeUp } from './presets/fade-up.mjs';
import { revealOnScroll } from './presets/reveal-on-scroll.mjs';
import { slideLeft } from './presets/slide-left.mjs';
import { slideRight } from './presets/slide-right.mjs';
import { staggerReveal } from './presets/stagger-reveal.mjs';
import { zoomIn } from './presets/zoom-in.mjs';

const defaultAnimations = [staggerReveal, fadeUp, fadeIn, slideLeft, slideRight, zoomIn, revealOnScroll];

function isMobileViewport(breakpoint = 768) {
    if (typeof window === 'undefined') {
        return false;
    }

    if (typeof window.matchMedia !== 'function') {
        return false;
    }

    return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
}

function initAnimations(root = typeof document !== 'undefined' ? document : null, options = {}) {
    const disableOnMobile = options.disableOnMobile === true;
    const mobileBreakpoint = Number.isFinite(options.mobileBreakpoint) ? options.mobileBreakpoint : 768;

    if (disableOnMobile && isMobileViewport(mobileBreakpoint)) {
        if (options.debug === true && typeof console !== 'undefined') {
            console.info('[speeder-animations] disabled on mobile', {
                breakpoint: mobileBreakpoint,
            });
        }

        return null;
    }

    const animator = createAnimator({
        once: options.once,
        observe: options.observe,
        threshold: options.threshold,
        rootMargin: options.rootMargin,
        motion: options.motion,
        debug: options.debug === true,
        animations: options.animations || defaultAnimations,
    });

    if (options.debug === true && typeof console !== 'undefined') {
        console.info('[speeder-animations] debug enabled', {
            debug: true,
            animations: (options.animations || defaultAnimations).map(animation => animation.name),
        });
    }

    return animator.init(root);
}

export { defaultAnimations, initAnimations };
